import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'filter-chip',
	imports: [MatChipsModule, NgxTolgeeModule, MatIconModule, MatMenuModule, CommonModule],
	templateUrl: './filter-chip.component.html',
	styleUrl: './filter-chip.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterChipComponent {
	title = input<string>();
	filterOptions = input<{ value: string; icon: string }[]>();

	filterSelected = output<string>();

	selectedFilter = signal<string>(null);

	setFilter(filter: string, event: Event | null) {
		this.selectedFilter.set(filter);
		this.filterSelected.emit(filter);

		if (event) {
			event.stopPropagation();
		}
	}
}
